














import { Component } from '@niknevis/vue-modules'
import EntitySearchSelect from '@/modules/common/entity-search/components/shared/EntitySearchSelect.vue'
import Vue from 'vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import { ModelSync, Prop } from 'vue-property-decorator'
import collect from 'collect.js'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'
import { AdminPersonService } from '@/modules/common/person/services/admin.person.service'

@Component({
  components: {
    BaseSelect,
    EntitySearchSelect
  }
})
export default class PersonSearch extends Vue {
  constructor(
    private readonly personService: AdminPersonService
  ) {
    super()
  }

  @ModelSync('value', 'input', { default: null }) val!: PersonTitle
  @Prop({ default: false }) clearable: boolean
  personList: { [key in PersonTitle]: string } = null

  mounted() {
    this.getPersons()
  }

  get personOptions() {
    return collect(this.personList).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  getPersons() {
    this.personService.getPersons().then((res) => {
      this.personList = res
    })
  }
}
